import { render, staticRenderFns } from "./DiscartDamageCultive.vue?vue&type=template&id=3f0b4ea8"
import script from "./DiscartDamageCultive.vue?vue&type=script&lang=js"
export * from "./DiscartDamageCultive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports